module.exports = __webpack_public_path__ + "img/wx-pay.972815c5.png";